<div class="dashboard-container">
    <h1>Stores Dashboard</h1>
    
    <div class="dashboard-grid">
      <mat-card (click)="navigateTo('creamsdash')" class="dashboard-card">
        <mat-card-header>
          <mat-card-title>Creams Overview</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>View yearly and monthly sales comparisons</p>
        </mat-card-content>
      </mat-card>
  
      <mat-card (click)="navigateTo('mhdash')" class="dashboard-card">
        <mat-card-header>
          <mat-card-title>MH Overview</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Analyze sales data for the past week</p>
        </mat-card-content>
      </mat-card>
  
    </div>
  </div>
  
  
  